import React from 'react'
import { useNode } from '@craftjs/core'
import { BibliographyBoxSettings } from './BibliographyBoxSettings'

import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

import { BibliographyBox as OriginalBibliographyBox } from 'react-components/molecules'

export const defaultProps = {}

export const dynamicProps = []

export const BibliographyBox = withBlock(
  props => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect, drag },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(state => ({
      selected: state.events.selected,
      hovered: state.events.hovered,
      customs: state.data.custom,
    }))

    return (
      <div ref={ref => props.retRef(ref)} className={'block-wbibliography-box ' + props.className}>
        <OriginalBibliographyBox
          title={children?.props?.children[0]}
          text={children?.props?.children[1]}
        >
          {children?.props?.children.filter((item, index) => index > 1)}
        </OriginalBibliographyBox>
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

BibliographyBox.craft = withCraft({
  name: 'BibliographyBox',
  defaultProps: defaultProps,
  settings: BibliographyBoxSettings,
})
